import React from "react";
import "./Panda.css";
const Panda = () => {
  return (
    <div id="get-started" className="g-wrapper">
      <div className="paddings innerWidth g-container">
        <div className="flexColCenter inner-container">
          <span className="primaryText">My Restaurant</span>
          <span className="secondaryText">
            Subscribe and find super attractive suprises from us.
            <br />
            Get your Order Now
          </span>
          <button className="button1" href>
            <a href="apurvasingh534@gmail.com">Get Started</a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Panda;